import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

export type GetSelectedNvalMediumListResponse ={
  MediumType: string,
  MediumName: string,
}
/**
 * 選定済1物N価媒体リスト取得サービス
 *
 * @export GetSelectedNvalMediumListService
 * @class GetSelectedNvalMediumListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSelectedNvalMediumListService extends PlessJsonResponderSub<GetSelectedNvalMediumListResponse[]> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetSelectedNvalMediumListService
   */
  private successFunc: Function = () => {};

  vo = {
    OrderCode: '',
    PCode: ''
  }

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSelectedNvalMediumListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetMediumList: {
          condition: {
            OrderCode: this.vo.OrderCode,
            PCode: this.vo.PCode
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSelectedNvalMediumListService
   */
  execute(vo: any, successFunc: Function = () => {}): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getSelectedNvalMediumList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSelectedNvalMediumListService
   */
  success(data: GetSelectedNvalMediumListResponse[]): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
